<template>
    <div class="select_item">
        <div class="control">
            <div class="help_close" @click="closeModal">
                <img
                        class="close_button"
                        src="../../assets/img/modal_close.svg"
                        alt="close_button"
                >
            </div>
        </div>
        <div class="content">
            <p class="caption">{{caption}}</p>
            <p>商品を選択してください</p>
            <div class="item_list_box">
                <ItemList
                        :item_type="editing_item.item_type"
                        :editing_item="editing_item"
                        @select_item="setItem"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
    import CONST from '../../assets/js/const'

    import ItemList from './parts/ItemList'

    export default {
        name: "SelectItem",
        components: { ItemList },
        computed: {
            ...mapState('simulator', ["editing_id"]),
            ...mapGetters('simulator', ["editing_item"]),
            caption: _this => {
                switch (_this.editing_item.item_type) {
                    case CONST.ITEM_TYPE_CURTAIN: {
                        return 'カーテン';
                    }
                    case CONST.ITEM_TYPE_WALL: {
                        return '壁紙';
                    }
                    case CONST.ITEM_TYPE_FLOOR: {
                        return '床材';
                    }
                }
            },
        },
        created() {
            if ( !this.editing_item ) this.setModal('SelectItemType');
        },
        methods: {
            ...mapMutations(["setModal"]),
            ...mapActions(["resetTimer"]),
            ...mapActions('simulator', ["updateItemInfo"]),
            async setItem(item_data) {
                this.setModal('');
                await this.updateItemInfo({id: this.editing_id, item_data});
                this.resetTimer();
            },
            closeModal() { this.setModal('') }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";

    .select_item{
        *{ margin: 0 }
        height: 100%;
        .control{
            display: flex;
            justify-content: flex-end;
            .help_close {
                padding: 0.5rem;
                @extend .clickable;
            }
        }
        .content{
            height: calc(100% - 3.5rem);
            .caption{
                padding-bottom: 0.25rem;
                font-size: 18px;
                text-align: center;
            }
            .item_list_box{
                max-height: calc(100% - 55px);
                overflow-y: auto;
            }
        }
    }
</style>
